import { libraryStateSignal } from "../library/books/states"
import { bookBeingReadStateSignal } from "../reading/states"
import { localSettingsSignal } from "../settings/useLocalSettings"
import { libraryShelvesFiltersSignal } from "../library/shelves/filters/states"
import { collectionDetailsScreenListControlsStateSignal } from "../pages/collections/CollectionDetailsScreen/CollectionDetailsScreen"
import { searchListActionsToolbarSignal } from "../search/list/states"
import type { SignalPersistenceConfig } from "reactjrx"

export const signalEntriesToPersist = [
  {
    signal: libraryStateSignal,
    version: 0,
    hydrate: ({ value }) => ({
      ...value,
      isLibraryUnlocked: false,
    }),
  } satisfies SignalPersistenceConfig<typeof libraryStateSignal>,
  { signal: libraryShelvesFiltersSignal, version: 0 },
  { signal: localSettingsSignal, version: 0 },
  { signal: bookBeingReadStateSignal, version: 0 },
  { signal: collectionDetailsScreenListControlsStateSignal, version: 0 },
  { signal: searchListActionsToolbarSignal, version: 0 },
]

export * from "./storage"
export * from "./active/activeProfileId"
export * from "./active/useIsActiveProfileHydrated"
export * from "./active/useActiveProfile"
export * from "./profilesBroadcast"
export * from "./useProfileById"
export * from "./useProfiles"
export * from "./useHasLoggedOutProfiles"
export * from "./useDeleteProfile"
export * from "./usePatchProfile"
export * from "./usePutProfile"
